import { Card, Title, Text, Button, ThemeIcon, Center } from '@mantine/core';
import { CheckCircle } from 'react-feather';

export interface SuccessConfirmationProps {
  cohortName: string;
  onReturn: () => void;
}

export function SuccessConfirmation({ cohortName, onReturn }: SuccessConfirmationProps) {
  return (
    <Center style={{ minHeight: '60vh' }}>
      <Card withBorder padding="xl" radius="lg" maw={500} ta="center">
        <ThemeIcon
          size={80}
          radius="xl"
          variant="light"
          color="green"
          mx="auto"
          mb="lg"
        >
          <CheckCircle size={40} />
        </ThemeIcon>
        <Title order={2} mb="sm">
          Response Submitted!
        </Title>
        <Text c="dimmed" mb="xl">
          Thank you for letting us know your availability for{' '}
          <Text component="span" fw={600}>
            {cohortName}
          </Text>
          . The Medley team will be in touch soon.
        </Text>
        <Button size="lg" color="dark" onClick={onReturn}>
          Return to Dashboard
        </Button>
      </Card>
    </Center>
  );
}
